import React from 'react'
import './ButtonSubmit.css'

interface ButtonSubmitProps {
  readonly text: string
  readonly type?: 'submit' | 'button' | 'reset'
  readonly onClick?: () => void
  readonly disabled?: boolean
}

function ButtonSubmit({ text, type = 'submit', onClick, disabled }: ButtonSubmitProps) {
  return (
    <div className="buttonSubmit">
      <button type={type} disabled={disabled} className="btn btn-primary" onClick={onClick}>
        {text}
      </button>
    </div>
  )
}

export default ButtonSubmit
